import React, { useState } from "react";
import { Box, Typography, Chip, Grid, Tabs, Tab } from "@mui/material";
import { FaPlus } from "react-icons/fa6";
import CustomButton from "components/Button";
import AddComplianceTracker from "./AddComplianceTracker";
import ObligationConcessionaireList from "./ObligationConcessionaireList";
import ObligationAuthorityList from "./ObligationAuthorityList";
import ObligationIEList from "./ObligationIEList";
import { usePermission } from "hooks/usePermission";
import { COMPLIANCE_CREATE } from "helpers/permissionConfig";
import { useParams } from "react-router-dom";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import TrackerPageHeader from "components/TrackerPageHeader";

const actionStatusOptions = [
    { label: "Obligation Concessionair ", value: "Obligation Concessionaire" },
    { label: "Obligation Authority", value: "Obligation Authority" },
    { label: "Obligation IE", value: "Obligation IE" },
];

const ComplianceTrackerList = () => {
    const { projectId } = useParams()
    const [tabValue, setTabValue] = useState(0);

    const [isAdd, setIsAdd] = useState(false)

    const createAccess = usePermission(COMPLIANCE_CREATE);
    const { data: complianceData } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });

    const handleAdd = () => {
        setIsAdd((prev) => !prev);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        // setCurrentPage(1);
    };

    return (
        <>
            <TrackerPageHeader title="Compliance Tracker" description="Monitor contractual obligations, ownership, and compliance progress.">
                {complianceData?.compliance && <ProjectLastUpdatedOn date={complianceData?.compliance} />}
            </TrackerPageHeader>
            <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={12}>
                    <Box
                        sx={{
                            width: "100%",
                            borderBottom: "2px solid #ECECEC",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                            p: 0,
                            display: "flex", alignItems: "center", justifyContent: 'space-between',
                            "-webkit-overflow-scrolling": "touch",
                        }}
                    >
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            TabIndicatorProps={{ style: { display: "none" } }}
                            variant="scrollable"
                            scrollButtons={false}
                            sx={{
                                justifyContent: "flex-start !important",
                                alignItems: "flex-start",
                                "& .MuiTabs-flexContainer": {
                                    justifyContent: "flex-start !important",
                                    gap: "30px",
                                },
                            }}
                        >
                            {[...actionStatusOptions.map(item => item.value)].map((label, index) => (
                                <Tab
                                    key={index}
                                    label={
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    lineHeight: "100%",
                                                    color: tabValue === index ? "#0E73F6" : "#7E7E7E",
                                                    fontFamily: "Outfit, sans-serif"
                                                }}
                                            >
                                                {label}
                                            </Typography>
                                            {/* {index !== 0 && (
                                                <Chip
                                                    label={0}
                                                    sx={{
                                                        height: "20px",
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                        lineHeight: 1,
                                                        backgroundColor: "#E5E9EB",
                                                        color: "#5F5F5F",
                                                    }}
                                                />
                                            )} */}
                                        </Box>
                                    }
                                    sx={{
                                        textTransform: "none",
                                        minWidth: "auto",
                                        paddingBottom: "14px",
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        borderBottom: tabValue === index ? "2px solid #0E73F6" : "2px solid transparent",
                                    }}
                                />
                            ))}
                        </Tabs>
                        {createAccess &&
                            <CustomButton
                                label="Create Compliance"
                                startIcon={<FaPlus />}
                                color="primary"
                                onClick={handleAdd}
                                sx={{
                                    backgroundColor: "#2563EB",
                                    fontFamily: 'Outfit',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    lineHeight: '100%',
                                    letterSpacing: '0px',
                                }}
                            />
                        }
                    </Box>
                </Grid>

                {tabValue == 0 &&
                    <ObligationConcessionaireList />
                }
                {tabValue == 1 &&
                    <ObligationAuthorityList />
                }

                {tabValue == 2 &&
                    <ObligationIEList />
                }

                {/* <Grid size={12}>
                    <Grid container>
                        <Grid size={{ md: 8, sm: 6 }}>
                            <Stack
                                direction="row"
                                spacing={1}
                                sx={{
                                    padding: "8px 0",
                                    alignItems: "center",
                                    minHeight: "40px"
                                }}
                            >
                                {filters.Topic && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Category:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Topic}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Topic')}
                                    />
                                )}

                                {filters.Status && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Status:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Status}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Status')}
                                    />
                                )}

                                {filters.ClosureDate && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Closure Date:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {moment(filters.ClosureDate).format('DD-MM-YYYY')}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('ClosureDate')}
                                    />
                                )}
                            </Stack>
                        </Grid>
                        <Grid size={{ md: 4, sm: 6 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: 'end',
                                    p: "8px 0px"
                                }}
                            >
                                <IconButton
                                    ref={anchorRef}
                                    onClick={handleToggle}
                                >
                                    <MdOutlineFilterAlt size={24} color="#48535B" />
                                </IconButton>
                                <Popper
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    placement="bottom-end"
                                    transition
                                    disablePortal={false}
                                    sx={{ zIndex: 2000 }}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {({ TransitionProps }) => (
                                        <Grow {...TransitionProps}>
                                            <Paper
                                                sx={{
                                                    mt: 1,
                                                    p: 2,
                                                    borderRadius: 1,
                                                    boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                    width: 300,
                                                }}
                                            >
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <Box>
                                                        <Grid container spacing={2}>
                                                            <Grid size={12}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Select Category</Typography>
                                                                <Select
                                                                    name="Topic"
                                                                    options={topicOptions}
                                                                    placeholder="Select Category"
                                                                    onChange={(option) => handleSelectChange(option, "Topic")}
                                                                    value={filters.Topic ? topicOptions.find(option => option.value === filters.Topic) : null}
                                                                />
                                                            </Grid>

                                                            <Grid size={12}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Select Status</Typography>
                                                                <Select
                                                                    name="Status"
                                                                    options={statusOptions}
                                                                    placeholder="Select Status"
                                                                    onChange={(option) => handleSelectChange(option, "Status")}
                                                                    value={filters.Status ? statusOptions.find(option => option.value === filters.Status) : null}
                                                                />
                                                            </Grid>

                                                            <Grid size={12}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Target Closure Date</Typography>
                                                                <TextField
                                                                    type="date"
                                                                    name="ClosureDate"
                                                                    value={filters.ClosureDate || ''}
                                                                    onChange={(e) => {
                                                                        const selectedDate = e.target.value;
                                                                        setFilters((prev) => ({
                                                                            ...prev,
                                                                            ClosureDate: selectedDate,
                                                                        }));
                                                                    }}
                                                                    onClick={(e) => {
                                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                        if (input) input.showPicker?.();
                                                                    }}
                                                                    fullWidth
                                                                    sx={{
                                                                        "& input::-webkit-calendar-picker-indicator": {
                                                                            display: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& input[type='date']": {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "& fieldset": {
                                                                                border: "none",
                                                                            },
                                                                        },
                                                                    }}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                                {calenderSVG}
                                                                            </Box>
                                                                        ),
                                                                        sx: {
                                                                            backgroundColor: "#E7E7EB",
                                                                            height: "40px",
                                                                            width: { xs: "100%", md: "100%" },
                                                                            borderRadius: "3px",
                                                                        },
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid size={12}>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <Button onClick={handleReset}
                                                                        sx={{
                                                                            textTransform: "none",
                                                                            color: "#F15744",
                                                                            fontSize: "14px",
                                                                            lineHeight: "100%",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            borderRadius: "3px",
                                                                            fontWeight: 500,
                                                                            px: "20px",
                                                                            py: "15px",
                                                                        }}>
                                                                        Reset
                                                                    </Button>
                                                                    <Button
                                                                        type="button"
                                                                        onClick={handleApplyFilters}
                                                                        variant="contained"
                                                                        sx={{
                                                                            backgroundColor: "#2563EB",
                                                                            borderRadius: "3px",
                                                                            textTransform: "none",
                                                                            fontWeight: 500,
                                                                            fontSize: "14px",
                                                                            lineHeight: "100%",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            color: "#FFFFFF",
                                                                            px: "20px",
                                                                            py: "15px",
                                                                        }}
                                                                    >
                                                                        Apply
                                                                    </Button>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                                <IconButton>
                                    <BiListUl size={24} color="#48535B" />
                                </IconButton>
                                <IconButton>
                                    <MdOutlineFileDownload size={24} color="#48535B" />
                                </IconButton>
                                <IconButton>
                                    <LuRefreshCw size={20} color="#48535B" />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <TableComponent
                        data={paginatedData}
                        isLoading={loading}
                        columns={columns}
                        order={order}
                        orderBy={orderBy}
                        createSortHandler={createSortHandler}
                    />
                    <CustomPagination
                        totalCount={totalCount}
                        pageSize={pageSize}
                        page={currentPage}
                        onPageChange={handlePageChange}
                        setCurrentPage={setCurrentPage}
                        onPageSizeChange={handlePageSizeChange}
                    />
                </Grid> */}
            </Grid>
            {isAdd &&
                <AddComplianceTracker open={isAdd} handleClose={handleAdd} />
            }
        </>
    );
}

export default ComplianceTrackerList;
